import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { substring3saq8ornu0luv as substring } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import {
  startsWith26w8qjqapeeq6 as startsWith,
  equals2v6cggk171b6e as equals,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { DefaultApolloException8w3ielfxng0h as DefaultApolloException } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  numberToDouble210hrknaofnhf as numberToDouble,
  toShort36kaw0zjdq3ex as toShort,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import { toTypedArray3sl1vhn8ifta0 as toTypedArray } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Paire9pteg33gng7 as Pair } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { copyToArray2j022khrow2yi as copyToArray } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { get_isNodeu9kqlebvup92 as get_isNode } from '../../internal/is-node.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var MAX_BUFFERED;
function WebSocketEngine() {
  return new (JsWebSocketEngine())();
}
var JsWebSocketEngineClass;
function JsWebSocketEngine() {
  if (JsWebSocketEngineClass === VOID) {
    class $ {
      p68(url, headers, listener) {
        return new (JsWebSocket())(url, headers, listener);
      }
      l6() {
      }
    }
    initMetadataForClass($, 'JsWebSocketEngine', JsWebSocketEngine);
    JsWebSocketEngineClass = $;
  }
  return JsWebSocketEngineClass;
}
var JsWebSocketClass;
function JsWebSocket() {
  if (JsWebSocketClass === VOID) {
    class $ {
      constructor(url, headers, listener) {
        this.t6b_1 = listener;
        this.v6b_1 = false;
        this.w6b_1 = startsWith(url, 'http://') ? 'ws://' + substring(url, 7) : startsWith(url, 'https://') ? 'wss://' + substring(url, 8) : url;
        this.u6b_1 = createWebSocket(this.w6b_1, headers, this.t6b_1);
        var tmp0_safe_receiver = this.u6b_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'org.w3c.dom.ARRAYBUFFER' call
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'kotlin.js.unsafeCast' call
          tmp0_safe_receiver.binaryType = 'arraybuffer';
        }
        var tmp1_safe_receiver = this.u6b_1;
        if (tmp1_safe_receiver == null)
          null;
        else {
          tmp1_safe_receiver.onopen = (it) => {
            this.t6b_1.s68();
            return Unit_instance;
          };
        }
        var tmp2_safe_receiver = this.u6b_1;
        if (tmp2_safe_receiver == null)
          null;
        else {
          tmp2_safe_receiver.onmessage = (it) => {
            var data2 = it.data;
            var tmp;
            if (!(data2 == null) ? typeof data2 === 'string' : false) {
              this.t6b_1.t68((!(data2 == null) ? typeof data2 === 'string' : false) ? data2 : THROW_CCE());
              tmp = Unit_instance;
            } else {
              if (data2 instanceof ArrayBuffer) {
                // Inline function 'kotlin.js.unsafeCast' call
                // Inline function 'kotlin.js.asDynamic' call
                var tmp$ret$3 = new Int8Array(data2 instanceof ArrayBuffer ? data2 : THROW_CCE());
                this.t6b_1.v68(tmp$ret$3);
                tmp = Unit_instance;
              } else {
                var d = JSON.stringify(data2);
                if (!this.v6b_1) {
                  this.v6b_1 = true;
                  this.t6b_1.w68(DefaultApolloException().p42("Apollo: unsupported message received ('" + d + "')"));
                  var tmp0_safe_receiver = this.u6b_1;
                  if (tmp0_safe_receiver == null)
                    null;
                  else {
                    tmp0_safe_receiver.close(1001, 'Unsupported message received');
                  }
                }
                tmp = Unit_instance;
              }
            }
            return Unit_instance;
          };
        }
        var tmp3_safe_receiver = this.u6b_1;
        if (tmp3_safe_receiver == null)
          null;
        else {
          tmp3_safe_receiver.onerror = (it) => {
            var tmp;
            if (!this.v6b_1) {
              this.v6b_1 = true;
              this.t6b_1.w68(DefaultApolloException().p42('Error while reading websocket'));
              tmp = Unit_instance;
            }
            return Unit_instance;
          };
        }
        var tmp4_safe_receiver = this.u6b_1;
        if (tmp4_safe_receiver == null)
          null;
        else {
          tmp4_safe_receiver.onclose = (it) => {
            var event = it;
            var tmp;
            if (!this.v6b_1) {
              this.v6b_1 = true;
              var tmp_0;
              if (event.wasClean) {
                this.t6b_1.x68(event.code, event.reason);
                tmp_0 = Unit_instance;
              } else {
                this.t6b_1.w68(DefaultApolloException().p42('WebSocket was closed'));
                tmp_0 = Unit_instance;
              }
              tmp = tmp_0;
            }
            return Unit_instance;
          };
        }
      }
      z68(data) {
        var tmp0_safe_receiver = this.u6b_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          if (numberToDouble(tmp0_safe_receiver.bufferedAmount) > MAX_BUFFERED) {
            if (!this.v6b_1) {
              this.v6b_1 = true;
              this.t6b_1.w68(DefaultApolloException().p42('Too much data queued'));
            }
          }
          tmp0_safe_receiver.send(new Uint8Array(toTypedArray(data)));
        }
      }
      a69(text) {
        var tmp0_safe_receiver = this.u6b_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          if (numberToDouble(tmp0_safe_receiver.bufferedAmount) > MAX_BUFFERED) {
            if (!this.v6b_1) {
              this.v6b_1 = true;
              this.t6b_1.w68(DefaultApolloException().p42('Too much data queued'));
            }
          }
          tmp0_safe_receiver.send(text);
        }
      }
      r68(code, reason) {
        if (!this.v6b_1) {
          this.v6b_1 = true;
          var tmp0_safe_receiver = this.u6b_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.close(toShort(code), reason);
          }
        }
      }
    }
    initMetadataForClass($, 'JsWebSocket');
    JsWebSocketClass = $;
  }
  return JsWebSocketClass;
}
function createWebSocket(urlString_capturingHack, headers, listener) {
  // Inline function 'kotlin.collections.partition' call
  var first = ArrayList().p2();
  var second = ArrayList().p2();
  var _iterator__ex2g4s = headers.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    if (equals(element.w48_1, 'sec-websocket-protocol', true)) {
      first.i2(element);
    } else {
      second.i2(element);
    }
  }
  var _destruct__k2r9zo = new (Pair())(first, second);
  var protocolHeaders = _destruct__k2r9zo.ze();
  var otherHeaders = _destruct__k2r9zo.af();
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().h2(collectionSizeOrDefault(protocolHeaders, 10));
  var _iterator__ex2g4s_0 = protocolHeaders.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var item = _iterator__ex2g4s_0.r1();
    var tmp$ret$4 = item.x48_1;
    destination.i2(tmp$ret$4);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var protocols = copyToArray(destination);
  var tmp;
  if (get_isNode()) {
    var ws_capturingHack = eval('require')('ws');
    var headers_capturingHack = new (createWebSocket$headers_capturingHack$1())();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_1 = headers.p1();
    while (_iterator__ex2g4s_1.q1()) {
      var element_0 = _iterator__ex2g4s_1.r1();
      headers_capturingHack[element_0.w48_1] = element_0.x48_1;
    }
    tmp = new ws_capturingHack(urlString_capturingHack, protocols, {headers: headers_capturingHack});
  } else {
    var tmp_0;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!otherHeaders.n1()) {
      setTimeout(() => {
        listener.w68(DefaultApolloException().p42("Apollo: the WebSocket browser API doesn't allow passing headers. Use connectionPayload or other mechanisms."));
        return Unit_instance;
      }, 10n);
      tmp_0 = null;
    } else {
      tmp_0 = new WebSocket(urlString_capturingHack, protocols);
    }
    tmp = tmp_0;
  }
  return tmp;
}
var createWebSocket$headers_capturingHack$1Class;
function createWebSocket$headers_capturingHack$1() {
  if (createWebSocket$headers_capturingHack$1Class === VOID) {
    class $ {}
    initMetadataForClass($);
    createWebSocket$headers_capturingHack$1Class = $;
  }
  return createWebSocket$headers_capturingHack$1Class;
}
//region block: init
MAX_BUFFERED = 100000000;
//endregion
//region block: exports
export {
  WebSocketEngine as WebSocketEngine1lh73ie4wh0m5,
};
//endregion

//# sourceMappingURL=WebSocketEngine.js.mjs.map
